import React, { useCallback, useState } from 'react'
import fileDownload from 'js-file-download'
import { isEmpty, join } from 'lodash'

import { showErrorNotification } from '../../../common/helpers'
import { useDocumentTitle } from '../../../common/hooks'

import { generateUsersReport } from '../../rest'
import { UsersReportForm } from '../forms'

const UserReportSection = () => {
  useDocumentTitle('Reports - User')
  const [isGeneratingReport, setIsGeneratingReport] = useState(false)

  const generateReport = useCallback(
    async filters => {
      try {
        setIsGeneratingReport(true)
        const reportReponse = await generateUsersReport(filters)

        fileDownload(reportReponse?.data, 'UsersReport.zip')
      } catch (error) {
        let errorMessage = error.message

        const { errors } = JSON.parse(
          (await error.response?.data?.text()) || '{}',
        )

        if (!isEmpty(errors)) {
          errorMessage = join(errors, '\n')
        }

        showErrorNotification({
          message: 'Failed to generate report.',
          description: errorMessage,
          type: 'error',
          duration: 0,
        })
      } finally {
        setIsGeneratingReport(false)
      }
    },
    [setIsGeneratingReport],
  )

  return (
    <UsersReportForm
      onSubmit={generateReport}
      isGeneratingReport={isGeneratingReport}
    />
  )
}

export default UserReportSection
